import { FileResponse } from '@shared/types/api';
import { AxiosResponse, isAxiosError } from 'axios';
import { Filter } from '@uni-space/uni-components';

export const makeQueryString = (
  page: number | undefined,
  pageSize: number | undefined,
  filters: Filter[] | undefined,
) => {
  let queryString = '';
  if (page === null) throw new Error("The parameter 'page' cannot be null.");
  else if (page !== undefined) queryString += 'Paging.Page=' + encodeURIComponent('' + page) + '&';
  if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
  else if (pageSize !== undefined) queryString += 'Paging.Size=' + encodeURIComponent('' + pageSize) + '&';
  if (filters === null) throw new Error("The parameter 'filters' cannot be null.");
  else if (filters !== undefined) {
    // preparationFilteredValues из uni-components возвращает undefined для незаполненного
    // date-фильтра, поэтому в массиве бывают дыры. Биндер ASP.NET Core читает Filters[n]
    // только по непрерывным индексам с нуля — нумеруем отдельным счётчиком, а не индексом массива.
    let filterIndex = 0;
    filters.forEach((item) => {
      if (!item) return;
      for (const attr in item) {
        if (Object.prototype.hasOwnProperty.call(item, attr)) {
          queryString +=
            'Filters[' + filterIndex + '].' + attr + '=' + encodeURIComponent('' + (item as any)[attr]) + '&';
        }
      }
      filterIndex++;
    });
  }
  queryString = queryString.replace(/[?&]$/, '');
  return queryString;
};

function throwException(message: any, _responseText: any, error: any, _headers: any) {
  throw new Error('Function not implemented.');
}

export const processFileResponse = (response: AxiosResponse): Promise<FileResponse | null> => {
  const status = response.status;
  const _headers: any = {};
  if (response.headers && response.headers.forEach) {
    response.headers.forEach((v: any, k: any) => (_headers[k] = v));
  }
  if (status === 200 || status === 206) {
    const contentDisposition = response.headers
      ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        response?.headers?.get('content-disposition')
      : undefined;
    const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
    const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;

    return Promise.resolve({
      fileName: fileName,
      data: response.data,
      status: status,
      headers: _headers,
    });
  } else if (status === 422) {
    return response.data.text().then((_responseText: any) => {
      const error = JSON.parse(_responseText);
      return throwException(error.message, _responseText, error, _headers);
    });
  } else {
    return response.data.text().then((_responseText: any) => {
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    });
  }
};

export function getErrorMessage(err: unknown): string {
  if (err instanceof Error) return err.message?.trim() || 'Неизвестная ошибка';

  if (isAxiosError(err)) {
    return (err.response?.data as any)?.message ?? err.message ?? 'Ошибка запроса';
  }

  if (typeof err === 'object' && err && 'message' in err) {
    return String(err.message);
  }

  return 'Неизвестная ошибка';
}
